import React, { useState, useEffect } from 'react';
import { Table, Button, Modal } from 'antd';
import labels from '../../util/labels.json';
import { useLocation, useNavigate } from 'react-router-dom';
// import '@ant-design/v5-patch-for-react-19';
import 'tailwindcss/tailwind.css';
import { cartViewPageColumns, pageSize, getRowClassName } from '../../util/columnsConfig.js';
import '../Admin/CartViewPage.css';
import { onboardingUsersInformationSendingMail } from '../../services/Service';
import { SendEmailConfirmButton,showNotification,showErrorNotification } from '../../util/documentConfig';

const CartViewPage = () => {
  const location = useLocation();
  const basePath = sessionStorage.getItem('APP_BASE_PATH')
  const navigate = useNavigate();
  const [selectedUsers, setSelectedUsers] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);

  // 🔹 Disable Page Scrolling
  useEffect(() => {
    document.body.style.overflow = "hidden"; // Prevents page scrolling
    return () => {
      document.body.style.overflow = "auto"; // Restores scrolling on unmount
    };
  }, []);

  useEffect(() => {
    if (location.state && location.state.selectedUsers) {
      setSelectedUsers(location.state.selectedUsers);
    }
  }, [location.state]);

  const handleSendEmail = async () => {
    try {
      const response = await onboardingUsersInformationSendingMail(selectedUsers);
      if (response.ok) {
        showNotification(labels.emailSuccessMessage)
        setSelectedUsers([]);
        navigate(`${basePath}/onboarding`);
      } else {
        throw new Error(labels.emailErrorMessage);
      }
    } catch (error) {
      showErrorNotification(error)
    }
};



  const handleBack = () => {
    navigate(`${basePath}/onboarding`, { state: { selectedUsers, gridData: location.state.gridData, selectedRowKeys: location.state.selectedRowKeys } });
  };

  const handleTableChange = (pagination) => {
    setCurrentPage(pagination.current);
  };

  const paginationColumns = [
    {
      title: 'Row #',
      key: 'rowNumber',
      width:80,
      render: (text, record, index) => (currentPage - 1) * pageSize + index + 1,
    },
    ...cartViewPageColumns.slice(1),
  ];

  return (
    <div className="max-w-7xl mx-auto p-3 bg-white space-y-8 mt-8 overflow-hidden"  style={{ height: '585px'}}>
      <h2 className="header">{labels.cartHeader}</h2>

      {/* Buttons & Info */}
      <div className="flex justify-between items-center p-4 flex-none mt-0 pt-0">
        <span className="text-lg font-semibold">
          Selected Users: {selectedUsers.length}
        </span>
        <div className="flex gap-2">
          <SendEmailConfirmButton
            onConfirm={() => handleSendEmail()}
          />
          <Button
            type="primary"
            className="bg-[#183D5D] text-white rounded-full px-5 py-5 text-xl flex items-center gap-4 shadow-xl"
            onClick={handleBack}
          >
            {labels.backButton}
          </Button>
        </div>
      </div>

      {/* Table Wrapper with Scroll & Sticky Header */}
      <div className="bg-white border border-gray-200 rounded-lg shadow-lg">
          <Table
            dataSource={selectedUsers}
            rowKey="uid"
            pagination={{
              pageSize,
              showSizeChanger: false,
              position: ['bottomCenter'], // Center align pagination
            }}
            className="bg-white"
            rowClassName={getRowClassName}
            onChange={handleTableChange}
            style={{ width: '100%' }}
            scroll={{ y: 250 }} // Scroll after 5 users
            columns={[
              ...paginationColumns.map(col => ({
                ...col,
                onHeaderCell: () => ({
                  style: {
                    backgroundColor: 'var(--color-primary)',
                    color: 'white',
                    fontWeight: 'bold',
                    position: 'sticky',
                    top: 0,
                    zIndex: 100,
                  },
                }),
              })),
            ]}
          />
        </div>
      </div>
  );
};

export default CartViewPage;
